import get from 'lodash/get'
import { AppStateType } from '../reducers'
import { createSelector } from 'reselect'
import { ICapabilitiesSummary } from '../types/capabilitiesSummary'
import { checkIfIsLightGroup } from '../services/groups'
import { EditionType } from '@graphics/gfx-common'

export const selectCapabilitiesSummary = createSelector(
  [(state: AppStateType) => state.capabilitiesSummary],
  (capabilitiesSummary) => capabilitiesSummary
)

export const selectCapabilitiesSummaryPerGroup = (groupId: string) =>
  createSelector(
    selectCapabilitiesSummary,
    ({ groups }): ICapabilitiesSummary | undefined => groups[groupId]
  )

export const selectIsLightGroup = (
  { capabilitiesSummary }: AppStateType,
  groupId: string
) =>
  checkIfIsLightGroup(
    get(capabilitiesSummary, `groups.${groupId}.editionTypes`, [] as EditionType[])
  )
